module.exports = __webpack_public_path__ + "img/graduated.83a46475.png";